import { defineComponent as _defineComponent } from 'vue'
import { ComplianceStatus } from 'ah-api-gateways';
import { complianceStatusLabels } from 'bd-common/src/models/complianceStatus';
import BDStatusPill from 'bd-common/src/components/common/BDStatusPill.vue';

/**
 * Client Status Pill for Bank Direct
 *
 * Currently only supports suspended and approved compliance cases, as those are the only ones shown in the UI
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientStatusPill',
  props: {
    status: null
  },
  setup(__props: any) {



const STATUS_COLORS: Partial<Record<ComplianceStatus, string>> = {
  [ComplianceStatus.SUSPENDED]: 'danger',
  [ComplianceStatus.APPROVED]: 'success',
};

return { __sfc: true,STATUS_COLORS, complianceStatusLabels, BDStatusPill }
}

})